import { useContext, useEffect, useLayoutEffect } from "react"
import Banner from "../components/home/Banner"
import Numbers from "../components/home/Numbers"
import OurPortfolio from "../components/home/OurPortfolio"
import OurPortfolioMobile from "../components/home/OurPortfolioMobile"
import SearchSection from "../components/home/SearchSection"
import Tomorrow from "../components/home/Tomorrow"
import Updates from "../components/home/Updates"
import UpdatesMobile from "../components/home/UpdatesMobile"
import { isMobileContext } from "../contexts/isMobileContext"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { useTranslation } from "next-i18next"
import { NextSeo } from "next-seo"
import { BASE_URL, fetchData } from "../utils/FetchData"
import { useState } from "react"
import { dehydrate, QueryClient, useQuery } from "react-query"
import { useRouter } from "next/router"
import { nextRouteContext } from "../contexts/nextRouteContext"
import { AnimatePresence } from "framer-motion"
import LoadingPage from "../components/LoadingPage"
import Footer from "@/components/common/Footer"

export default function Home() {
	const { isMobile } = useContext(isMobileContext)
	const { t } = useTranslation("common")
	const { locale } = useRouter()
	const [homeData, setHomeData] = useState()
	const { nextRoute, isWebsiteLoading, setIsWebsiteLoading } =
		useContext(nextRouteContext)
	const { data, isSuccess, isLoading, isError, isFetching } = useQuery(
		["homeData", locale],
		() =>
			fetchData(
				"home",
				locale,
				"populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=FactsAndFigures&populate[3]=Our_Portfolio.Project_Tabs&populate[4]=News_Heighlights.Articles.img_desktop&populate[5]=News_Heighlights.Articles.banner_desktop&populate[6]=News_Heighlights.Articles.banner_mobile&populate[7]=News_Heighlights.Articles.img_desktop&populate[8]=News_Heighlights.Articles.img_mobile&populate[9]=News_Heighlights.Articles.card_img_desktop&populate[10]=News_Heighlights.Articles.card_img_mobile&populate[11]=News_Heighlights.Articles.home_card_img_desktop&populate[12]=News_Heighlights.Articles.home_card_img_mobile&populate[13]=News_Heighlights.Articles.article_tab&populate[14]=Our_Portfolio.Project_Tabs.projects&populate[15]=Our_Portfolio.Project_Tabs.projects.Project_Overview&populate[16]=Our_Portfolio.Project_Tabs.projects.Home_Card&populate[17]=Our_Portfolio.Project_Tabs.projects.Home_Card.Img_Desktop&populate[18]=Our_Portfolio.Project_Tabs.projects.Home_Card.Img_Mobile&populate[19]=Our_Portfolio.Project_Tabs.projects.Home_Card.Logo&populate[20]=Our_Portfolio.Project_Tabs.projects.Banner.Project_Name&populate[21]=Our_Portfolio.Project_Tabs.projects.Banner.Headline&populate[22]=Our_Portfolio.Project_Tabs.projects.phases&populate[23]=Our_Portfolio.Project_Tabs.business_projects&populate[24]=Our_Portfolio.Project_Tabs.business_projects.Home_Card&populate[25]=Our_Portfolio.Project_Tabs.business_projects.Home_Card.Img_Desktop&populate[26]=Our_Portfolio.Project_Tabs.business_projects.Banner.Project_Name&populate[27]=Our_Portfolio.Project_Tabs.business_projects.Banner.Headline&populate[28]=Our_Portfolio.Project_Tabs.business_projects.Home_Card.Img_Mobile&populate[29]=Our_Portfolio.Project_Tabs.commercial_projects&populate[30]=Our_Portfolio.Project_Tabs.commercial_projects.Home_Card&populate[31]=Our_Portfolio.Project_Tabs.commercial_projects.Home_Card.Img_Desktop&populate[32]=Our_Portfolio.Project_Tabs.commercial_projects.Banner.Project_Name&populate[33]=Our_Portfolio.Project_Tabs.commercial_projects.Banner.Headline&populate[34]=Our_Portfolio.Project_Tabs.commercial_projects.Home_Card.Img_Mobile&populate[35]=Our_Portfolio.Project_Tabs.business_projects.Home_Card.Logo&&populate[36]=Our_Portfolio.Project_Tabs.commercial_projects.Home_Card.Logo&&populate[37]=SEO.Img"
			)
	)
	const [pageLoading, setPageLoading] = useState(true)
	useEffect(() => {
		let timeOut = ""
		setPageLoading(true)
		let deviceType = /iPad/.test(navigator.userAgent)
			? "t"
			: /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
					navigator.userAgent
			  )
			? "m"
			: "d"
		window.criteo_q.push(
			{ event: "setAccount", account: 107694 },
			{ event: "setSiteType", type: deviceType },
			{ event: "viewHome" }
		)
		if (!isLoading) {
			timeOut = setTimeout(() => {
				setPageLoading(false)
			}, 3500)
		}
		return () => clearTimeout(timeOut)
	}, [isLoading, isSuccess])
	useEffect(() => {
		if (isSuccess) {
			setHomeData(data?.data?.attributes)
		}
	}, [data, isSuccess])

	// if (pageLoading) {
	// 	return <LoadingPage />;
	// }
	if (data?.error?.status == 404 || isError) {
		return <LoadingPage error />
	}
	return (
		<>
			<NextSeo
				title={data?.data?.attributes?.SEO?.Title}
				description={data?.data?.attributes?.SEO?.Description}
				openGraph={{
					type: "website",
					url: "https://www.hydeparkdevelopments.com",
					title: data?.data?.attributes?.SEO?.Title,
					images: [
						{
							url:
								BASE_URL +
								data?.data?.attributes?.SEO?.Img?.data?.attributes?.url,
						},
					],
					siteName: "Hyde Park Developments",
				}}
			/>
			<LoadingPage pageLoading={pageLoading} />
			<Banner
				pageLoading={pageLoading}
				bannerData={homeData?.Banner?.Slider}
				projectsTabs={homeData?.Our_Portfolio?.Project_Tabs?.data}
			/>
			{isMobile && <SearchSection />}
			<Numbers FactsAndFigures={homeData?.FactsAndFigures} />
			<AnimatePresence>
				{isMobile ? (
					<OurPortfolioMobile Our_Portfolio={homeData?.Our_Portfolio} />
				) : (
					<OurPortfolio Our_Portfolio={homeData?.Our_Portfolio} />
				)}
			</AnimatePresence>
			<AnimatePresence>
				{isMobile ? (
					<UpdatesMobile News_Heighlights={homeData?.News_Heighlights} />
				) : (
					<Updates News_Heighlights={homeData?.News_Heighlights} />
				)}
			</AnimatePresence>
			<Tomorrow />
			<Footer Our_Portfolio={homeData?.Our_Portfolio?.Project_Tabs} />
		</>
	)
}
export async function getServerSideProps({ locale }) {
	const queryClient = new QueryClient()
	await queryClient.prefetchQuery(["homeData", locale], () =>
		fetchData(
			"home",
			locale,
			"populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=FactsAndFigures&populate[3]=Our_Portfolio.Project_Tabs&populate[4]=News_Heighlights.Articles.img_desktop&populate[5]=News_Heighlights.Articles.banner_desktop&populate[6]=News_Heighlights.Articles.banner_mobile&populate[7]=News_Heighlights.Articles.img_desktop&populate[8]=News_Heighlights.Articles.img_mobile&populate[9]=News_Heighlights.Articles.card_img_desktop&populate[10]=News_Heighlights.Articles.card_img_mobile&populate[11]=News_Heighlights.Articles.home_card_img_desktop&populate[12]=News_Heighlights.Articles.home_card_img_mobile&populate[13]=News_Heighlights.Articles.article_tab&populate[14]=Our_Portfolio.Project_Tabs.projects&populate[15]=Our_Portfolio.Project_Tabs.projects.Project_Overview&populate[16]=Our_Portfolio.Project_Tabs.projects.Home_Card&populate[17]=Our_Portfolio.Project_Tabs.projects.Home_Card.Img_Desktop&populate[18]=Our_Portfolio.Project_Tabs.projects.Home_Card.Img_Mobile&populate[19]=Our_Portfolio.Project_Tabs.projects.Home_Card.Logo&populate[20]=Our_Portfolio.Project_Tabs.projects.Banner.Project_Name&populate[21]=Our_Portfolio.Project_Tabs.projects.Banner.Headline&populate[22]=Our_Portfolio.Project_Tabs.projects.phases&populate[23]=Our_Portfolio.Project_Tabs.business_projects&populate[24]=Our_Portfolio.Project_Tabs.business_projects.Home_Card&populate[25]=Our_Portfolio.Project_Tabs.business_projects.Home_Card.Img_Desktop&populate[26]=Our_Portfolio.Project_Tabs.business_projects.Banner.Project_Name&populate[27]=Our_Portfolio.Project_Tabs.business_projects.Banner.Headline&populate[28]=Our_Portfolio.Project_Tabs.business_projects.Home_Card.Img_Mobile&populate[29]=Our_Portfolio.Project_Tabs.commercial_projects&populate[30]=Our_Portfolio.Project_Tabs.commercial_projects.Home_Card&populate[31]=Our_Portfolio.Project_Tabs.commercial_projects.Home_Card.Img_Desktop&populate[32]=Our_Portfolio.Project_Tabs.commercial_projects.Banner.Project_Name&populate[33]=Our_Portfolio.Project_Tabs.commercial_projects.Banner.Headline&populate[34]=Our_Portfolio.Project_Tabs.commercial_projects.Home_Card.Img_Mobile&populate[35]=Our_Portfolio.Project_Tabs.business_projects.Home_Card.Logo&populate[36]=Our_Portfolio.Project_Tabs.commercial_projects.Logo&&populate[37]=SEO.Img"
		)
	)

	return {
		props: {
			dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
			...(await serverSideTranslations(locale, ["common"])),
		},
	}
}
